import React from 'react';
import Grid from '@material-ui/core/Grid';
import { InlineFilters } from 'features/command-center';
import { INLINE_FILTERS_KEYS } from 'features/command-center/constants';
import queryString from 'query-string';

import { FallOffsBoardWidgets, FallOffsByRecruiter, FallOffsByWeek } from './components';
import { formatFallOffsBoardFilters } from './fallOffsBoard.utils';
import { useFallOffsBoard } from './hooks';

const INLINE_FILTERS = ['employeeNumbers', 'teams', 'employeeStatuses'];

export const FallOffsBoard = () => {
  const { extraFilters, filters, handleFiltersChange, loading } = useFallOffsBoard();
  const filtersParams = formatFallOffsBoardFilters(filters);
  const queryParams = queryString.stringify(filtersParams, { arrayFormat: 'comma' });

  return (
    <>
      <InlineFilters
        filters={INLINE_FILTERS}
        extraFilters={extraFilters}
        onFiltersChange={handleFiltersChange}
        persistenceKey={INLINE_FILTERS_KEYS.financial.fallOffsBoard}
      />

      <Grid container spacing={3}>
        {!loading && <FallOffsBoardWidgets queryParams={queryParams} />}

        <Grid item xs={12}>
          <FallOffsByWeek queryParams={queryParams} />
        </Grid>

        <Grid item xs={12}>
          <FallOffsByRecruiter queryParams={queryParams} />
        </Grid>
      </Grid>
    </>
  );
};
